export const enum ContactType {
  sms = 0,
  email = 1,
}